import {UseCase} from '@s-ui/domain'

/**
 * @class
 * @implements UseCase
 */
export default class SetUserProfileNotificationsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.repository
   */
  constructor({repository}) {
    super()

    this._repository = repository
  }

  execute = ({isPortalAnnoucementsShowed = true} = {}) => {
    return this._repository.setPortalAnnoucementsShowed({
      isPortalAnnoucementsShowed
    })
  }
}
